import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils';
import { SingleNotePDF } from './SingleNotePDF';
import defaults from '../../../translations/en.json';

const NoNotesDataComponent = ({
  dashboardPrintConfig,
  title,
  widgetTitle
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.CPFTableDetailsText, styles.mYPointFiveCm]
}, `${defaults.thereWereNo} ${title || widgetTitle} ${dashboardPrintConfig && dashboardPrintConfig.fromDate && dashboardPrintConfig.toDate ? defaults.foundForDaysSelected : defaults.foundForThisPatient}`));

const AllNotesUI = ({
  ordersPageConfig,
  widgetTitle,
  title,
  notes,
  pdfPSOComponents,
  dashboardPrintConfig
}) => {
  const allNotesPDF = notes.map((note, i) => /*#__PURE__*/React.createElement(SingleNotePDF, {
    ordersPageConfig: ordersPageConfig,
    key: note.id,
    pnNote: note,
    index: i,
    pdfPSOComponents: pdfPSOComponents
  }));
  return notes.length > 0 && allNotesPDF || /*#__PURE__*/React.createElement(NoNotesDataComponent, {
    dashboardPrintConfig: dashboardPrintConfig,
    title: title,
    widgetTitle: widgetTitle
  });
};

const AllNotesWithTitleUI = ({
  notes,
  title,
  pdfPSOComponents,
  isCombined,
  ordersPageConfig,
  dashboardPrintConfig
}) => /*#__PURE__*/React.createElement(View, null, isCombined && /*#__PURE__*/React.createElement(View, {
  style: title === defaults.orders ? [styles.textAlignCenter, styles.width100, styles.marginBottomPointFiveCm] : [styles.textAlignCenter, styles.width100, styles.mYPointFiveCm]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.fontWeightBold, styles.fontSizeTenPt, styles.textDecorationUnderline]
}, title)), /*#__PURE__*/React.createElement(AllNotesUI, {
  dashboardPrintConfig: dashboardPrintConfig,
  ordersPageConfig: ordersPageConfig,
  notes: notes,
  pdfPSOComponents: pdfPSOComponents,
  title: title
}));

export const AllProgressNotesPDF = ({
  widgetTitle,
  notes,
  isCombined,
  pdfPSOComponents,
  ordersPageConfig,
  dashboardPrintConfig
}) => {
  if (notes) {
    if (isCombined) {
      return Object.entries(notes).reduce((seed, note) => {
        const title = note[0];
        const data = note[1];
        data && seed.push( /*#__PURE__*/React.createElement(AllNotesWithTitleUI, {
          ordersPageConfig: ordersPageConfig,
          key: title,
          notes: data,
          title: title,
          pdfPSOComponents: pdfPSOComponents,
          isCombined: isCombined,
          dashboardPrintConfig: dashboardPrintConfig
        }));
        return seed;
      }, []);
    }

    return /*#__PURE__*/React.createElement(AllNotesUI, {
      dashboardPrintConfig: dashboardPrintConfig,
      ordersPageConfig: ordersPageConfig,
      widgetTitle: widgetTitle,
      notes: notes,
      pdfPSOComponents: pdfPSOComponents
    });
  }

  return null;
};